/**
 * Salary credits have no merchant or person, so the entity-based categorizer
 * never touches them and a new user's first import shows "no income" despite a
 * salary credit (UAT J4-01). Deterministic, on-device: a credit whose
 * narration says SALARY / PAYROLL / SAL CR is income.
 */
const SALARY = /\bSALARY\b|\bPAYROLL\b|\bSAL\s?CR\b/i

export interface IncomeCandidateRow {
  id: string
  type: "debit" | "credit"
  description: string
  categoryId: string | null
  isTransfer: boolean
  isIgnored: boolean
}

/** Ids of uncategorised credits that are clearly salary. */
export function salaryCreditIds(rows: IncomeCandidateRow[]): string[] {
  return rows
    .filter(
      (r) =>
        r.type === "credit" &&
        !r.categoryId &&
        !r.isTransfer &&
        !r.isIgnored &&
        SALARY.test(r.description),
    )
    .map((r) => r.id)
}
